import React from "react";
// @ts-ignore
import classes from "./styles.module.css";

interface CardFormProps {
  isDarkMode?: boolean;
  id: string;
  isDisabled: boolean;
  isCardNumberValid: boolean;
  isExpirationValid: boolean;
  isSecurityCodeValid: boolean;
  cardHolderName: string;
  isCardHolderNameValid: boolean;
  cardHolderNameInputRef?: React.RefObject<HTMLInputElement | null>;
  buttonTitle?: string;
  loading?: boolean;
  handleCardHolderNameBlur: (e: any) => void;
  handleCardHolderNameChange: (e: any) => void;
  onSubmit: (e: any) => void;
}

export const CardForm: React.FC<CardFormProps> = ({
  isDarkMode,
  id,
  isDisabled,
  isCardNumberValid,
  isExpirationValid,
  isSecurityCodeValid,
  isCardHolderNameValid,
  cardHolderName,
  cardHolderNameInputRef,
  buttonTitle,
  loading,
  handleCardHolderNameBlur,
  handleCardHolderNameChange,
  onSubmit,
}) => {
  return (
    <div key={id} className={classes.form}>
      <div className={classes.fieldContainer}>
        {/* <label htmlFor={`card_number_id_${id}`} className={classes.label}>
          {t(STATIC_TRANSLATIONS.paymentPopup.cardElementTruegate.cardNumber)}
          Card number
        </label> */}
        <div
          id={`card_number_id_${id}`}
          className={`${classes.sdkField} ${!isCardNumberValid ? classes.sdkFieldError : ""}`}
        />
      </div>
      <div className={classes.fieldsRow}>
        <div className={classes.fieldFlex}>
          {/* <label htmlFor={`expiration_id_${id}`} className={classes.label}>
            {t(STATIC_TRANSLATIONS.paymentPopup.cardElementTruegate.date)}
            Expiration date
          </label> */}
          <div
            id={`expiration_id_${id}`}
            className={`${classes.sdkField} ${!isExpirationValid ? classes.sdkFieldError : ""}`}
          />
        </div>

        <div className={classes.fieldFlex}>
          {/* <label htmlFor={`security_code_id_${id}`} className={classes.label}>
            {t(STATIC_TRANSLATIONS.paymentPopup.cardElementTruegate.cvv)}
            Security code
          </label> */}
          <div
            id={`security_code_id_${id}`}
            className={`${classes.sdkField} ${!isSecurityCodeValid ? classes.sdkFieldError : ""}`}
          />
        </div>
      </div>

      <div className={classes.fieldContainer}>
        {/* <label htmlFor={`card_holder_name`} className={classes.label}>
          Name on card
          {t(STATIC_TRANSLATIONS.paymentPopup.cardElementTruegate.name)}
        </label> */}
        <input
          id={`card_holder_name`}
          type="text"
          autoComplete="cc-name"
          value={cardHolderName}
          onChange={handleCardHolderNameChange}
          placeholder="Name on Card"
          required
          onBlur={handleCardHolderNameBlur}
          className={`${classes.input} ${!isCardHolderNameValid ? classes.sdkFieldError : ""}`}
          ref={cardHolderNameInputRef}
        />
      </div>

      <button
        type="submit"
        onClick={onSubmit}
        disabled={isDisabled || loading}
        className={classes.button}
      >
        {loading ? <span className={classes.spinner} /> : buttonTitle}
      </button>
    </div>
  );
};
